<clr-vertical-nav
	class="nav-trigger--bottom h-100"
	[clrVerticalNavCollapsible]="collapsible"
	[(clrVerticalNavCollapsed)]="collapse">
	<a clrVerticalNavLink routerLink="dashboard" routerLinkActive="active">
		<cds-icon clrVerticalNavIcon shape="pie-chart"></cds-icon>
		{{ 'menu.left.dashboard.main_section' | translate }}
	</a>

	<div class="nav-divider"></div>

	<a clrVerticalNavLink routerLink="/acquisitions" routerLinkActive="active">
		<cds-icon clrVerticalNavIcon shape="employee"></cds-icon>
		Acquisition
	</a>

	<div class="nav-divider"></div>

	<a clrVerticalNavLink routerLink="/renewal/board" routerLinkActive="active">
		<cds-icon clrVerticalNavIcon shape="recycle"></cds-icon>
		Renewal
	</a>

    <div class="nav-divider"></div>

	<clr-vertical-nav-group routerLinkActive="active" *hasAccess="ACCESS_RIGHTS.VIEW_REGISTRATION_OVERVIEW">
		<cds-icon shape="note" clrVerticalNavIcon></cds-icon>
		{{ 'menu.left.registration.main_section' | translate }}
		<clr-vertical-nav-group-children>
			<a clrVerticalNavLink *hasAccess="ACCESS_RIGHTS.VIEW_REGISTRATION_OVERVIEW" routerLink="/registrations">
				{{ 'menu.left.registration.section_consultation' | translate }}
			</a>
			<a clrVerticalNavLink *hasAccess="ACCESS_RIGHTS.VIEW_WORKLIST_OVERVIEW" routerLink="/registrations/working-list">
				{{ 'menu.left.registration.section_working-list' | translate }}
			</a>
			<a *hasAccess="ACCESS_RIGHTS.VIEW_BUYING_GROUP" clrVerticalNavLink routerLink="/registrations/buying-group">
				{{ 'menu.left.registration.section_buying-group' | translate }}
			</a>
			<a clrVerticalNavLink *hasAccess="ACCESS_RIGHTS.REPORTING" routerLink="/registrations/reporting">
				{{ 'menu.left.reporting.main_section' | translate }}
			</a>
		</clr-vertical-nav-group-children>
	</clr-vertical-nav-group>

    <div *hasAccess="ACCESS_RIGHTS.VIEW_REGISTRATION_OVERVIEW" class="nav-divider"></div>

	<clr-vertical-nav-group routerLinkActive="active" *hasAccess="ACCESS_RIGHTS.MOVE_VIEW">
		<cds-icon shape="two-way-arrows" clrVerticalNavIcon></cds-icon>
		{{ 'menu.left.move.main_section' | translate }}
		<clr-vertical-nav-group-children>
			<a clrVerticalNavLink *hasAccess="ACCESS_RIGHTS.MOVE_VIEW" routerLink="/move">
				{{ 'menu.left.registration.section_consultation' | translate }}
			</a>
			<a clrVerticalNavLink *hasAccess="ACCESS_RIGHTS.MOVE_WORKING_LIST" routerLink="/move/working-list">
				{{ 'menu.left.registration.section_working-list' | translate }}
			</a>
			<a clrVerticalNavLink *hasAccess="ACCESS_RIGHTS.REPORTING" routerLink="/move/reporting">
				{{ 'menu.left.reporting.main_section' | translate }}
			</a>
		</clr-vertical-nav-group-children>
	</clr-vertical-nav-group>

    <div *hasAccess="ACCESS_RIGHTS.MOVE_VIEW" class="nav-divider"></div>

	<clr-vertical-nav-group routerLinkActive="active">
		<cds-icon shape="slider" clrVerticalNavIcon></cds-icon>
		{{ 'menu.left.simulation.main_section' | translate }}
		<clr-vertical-nav-group-children>
			<a *hasAccess="ACCESS_RIGHTS.SIMULATION_CREATE" clrVerticalNavLink routerLink="/simulation/simulation-create">
				{{ 'menu.left.simulation.simulation-create.main_section' | translate }}
			</a>
			<a clrVerticalNavLink routerLink="/simulation/search">
				{{ 'menu.left.simulation.simulation-search.main_section' | translate }}
			</a>
			<a *hasAccess="ACCESS_RIGHTS.SIMULATION_REPORTING" clrVerticalNavLink routerLink="/simulation/reporting">
				{{ 'menu.left.reporting.main_section' | translate }}
			</a>
		</clr-vertical-nav-group-children>
	</clr-vertical-nav-group>

    <div class="nav-divider"></div>

	<clr-vertical-nav-group routerLinkActive="active" *hasAccess="ACCESS_RIGHTS.PRODUCT_SERVICES_VIEW">
		<cds-icon shape="contract" clrVerticalNavIcon></cds-icon>
		{{ 'menu.left.product-services.main_section' | translate }}
		<clr-vertical-nav-group-children>
			<a clrVerticalNavLink *hasAccess="ACCESS_RIGHTS.PRODUCT_SERVICES_CREATE" routerLink="/product-services/create">
				{{ 'menu.left.product-services.create.main_section' | translate }}
			</a>
			<a clrVerticalNavLink *hasAccess="ACCESS_RIGHTS.PRODUCT_SERVICES_VIEW" routerLink="/product-services/search">
				{{ 'menu.left.product-services.search.main_section' | translate }}
			</a>
		</clr-vertical-nav-group-children>
	</clr-vertical-nav-group>

	<div class="nav-divider"></div>

	<clr-vertical-nav-group routerLinkActive="active">
		<cds-icon shape="unlock" clrVerticalNavIcon></cds-icon>
		{{ 'menu.left.admin.main_section' | translate }}

		<clr-vertical-nav-group-children>
			<a clrVerticalNavLink routerLink="monitoring" routerLinkActive="active">Camunda</a>
		</clr-vertical-nav-group-children>

		<clr-vertical-nav-group-children>
			<a clrVerticalNavLink routerLink="caches" routerLinkActive="active">Caches</a>
		</clr-vertical-nav-group-children>

		<clr-vertical-nav-group-children *hasAccess="ACCESS_RIGHTS.VIEW_DOCUMENTS_TEMPLATE_MANAGER">
			<a clrVerticalNavLink routerLink="documents-template-manager" routerLinkActive="active">Documents</a>
		</clr-vertical-nav-group-children>
	</clr-vertical-nav-group>

	<div *ngIf="!collapse">
		<div *hasAccess="ACCESS_RIGHTS.VIEW_PIPELINE_DATA" class="pipeline_data">
			<p>
				F :
				<a
					[href]="
						'https://gitlab.lampiris.be/activation/be-regstar-frontend/-/pipelines/' + pipelineData?.frontend?.pipeline_id
					">
					{{ pipelineData?.frontend?.pipeline_id }}
				</a>
				<span>- {{ pipelineData?.frontend?.pipeline_timestamp | date: 'dd/MM HH:mm' }}</span>
			</p>
			<p>
				B :
				<a
					[href]="
						'https://gitlab.lampiris.be/activation/be-regstar-backend/-/pipelines/' + pipelineData?.backend?.pipeline_id
					">
					{{ pipelineData?.backend?.pipeline_id }}
				</a>
				<span>- {{ pipelineData?.backend?.pipeline_timestamp | date: 'dd/MM HH:mm' }}</span>
			</p>
			<p>
				P :
				<a
					[href]="
						'https://gitlab.lampiris.be/activation/be-regstar-process/-/pipelines/' + pipelineData?.process?.pipeline_id
					">
					{{ pipelineData?.process?.pipeline_id }}
				</a>
				<span>- {{ pipelineData?.process?.pipeline_timestamp | date: 'dd/MM HH:mm' }}</span>
			</p>
		</div>
	</div>
	<span class="version" *ngIf="!collapse">regstar-be-{{ appVersion }}</span>
</clr-vertical-nav>
